export default class SalesByFiscalNumberController {
  constructor(ContentService, moment) {
    this.service = ContentService;
    this.moment = moment;
  }
  $onInit(){
    this.subscriptions = [];

    this.dateFrom = this.moment();
    this.dateTo = this.moment();
    this.rows;
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getSalesByNCF(){
    this.subscriptions.push(
      this.service.getSalesByNCF(this.dateFrom.toISOString(), this.dateTo.toISOString()).subscribe(data => {
        this.rows = data.rows;
      })
    );
  }

  getTotal(row){
    return row.total;
  }

  getTax(row){
    return row.tax;
  }

}

 SalesByFiscalNumberController.$inject = ['ContentService', 'moment'];



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-fiscal-number/sales-by-fiscal-number.controller.js